module.exports = __webpack_public_path__ + "img/minus.e8f53a89.svg";